export const Text = require("./Text").default
